module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules03-12c6a8b9a032b428da03b156aac326be.png";